// extracted by mini-css-extract-plugin
export var spMenu = "SPMenu-module--spMenu--1OpET";
export var spMenuActive = "SPMenu-module--spMenu--active--3apbX";